<template>
  <div>
    <Main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @edit="edit"
    >
      <Header
        slot="header"
        ref="header"
        @query="getData"
        @reset="resetPage"
        @add="edit({ type: 'add' })"
      />

      <pagination
        slot="pager"
        size="small"
        align="right"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>

    <EditForm
      :visible.sync="editOpts.visible"
      :type="editOpts.type"
      :inspectionAqlCode="editOpts.inspectionAqlCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
import Header from './header.vue'
import EditForm from '../edit-form/index.vue'
export default {
  components: { Main, Header, EditForm },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      editOpts: { visible: false, type: '', inspectionAqlCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpInspectionAqlListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    edit({ type, row: { inspectionAqlCode = '' } = {} } = {}) {
      this.editOpts = { visible: true, type, inspectionAqlCode }
    },
  },
}
</script>
